<!-- 
	AdminUser
	role: Admin
	Allows admin to view individual user profile along with notes specific to the user id
-->

<template>
	<div class="admin-user text-white">
		<div v-if="user.loggedIn === true && user.apiData.IsStrideAdmin === true">
			<AdminUserData v-bind:user="user" />
			<AdminNotes v-bind:user="user" />
		</div>
		<div v-else>
			You must be a Stride Administrator to access this page.<br />If you believe
			this is an error please contact support.
		</div>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";

	import AdminUserData from "@/components/AdminUserData";
	import AdminNotes from "@/components/AdminNotes";

	export default {
		name: "AdminUserPage",
		components: {
			AdminUserData,
			AdminNotes,
		},
		computed: {
			...mapGetters({
				user: "user",
			}),
		},
	};
</script>
